<template>
  <div class='contribution_wrap' v-if="apidata">
    <div v-if="contribution.type === 'singleimg'" class='text'>
      <div class='footerLink issue_title'>by {{contribution.name.toUpperCase()}}</div>
      <img v-bind:src="contribution.url" :class="contribution.orientation" class="image single_image">
    </div>
    
    <div v-else-if="contribution.type === 'text'" class='text'>
      <div class='noMargin' v-html='contribution.title.toUpperCase()'></div>
      <div class='footerLink'>by {{contribution.name.toUpperCase()}}</div>
      <section v-html='removeDspaces(contribution.text)' class='letterspacingMed'></section>
    </div>
    
    <div v-else class='text'>
      <div class='footerLink issue_title'>by {{contribution[0].name.toUpperCase()}}</div>
      <img v-for="image in contribution" v-bind:src="image.url" :class="image.orientation" class="image image_multiple">
    </div>

    
  </div>  
</template>

<script>
import _ from 'underscore'

export default {
  name: 'IssueInner',
  props: ['index', 'id'],
  computed: {
    apidata () {
      return this.$store.state.apidata
    },
    issues () {
      return this.apidata['1-issues']
    }, 
    issue () {
      return this.issues[this.index]
    },
    sort () {
      const sort = this.id.split("-")
      const sortValue = sort[sort.length-1]

      return sortValue
    },
    contribution () {
      const nameA = this.id.split("-")
      const nameB = nameA.pop()
      const nameC = nameA.join(" ")

      if(this.sort === 'image') {
        const outer = this.issue.imageContributionsSingle

        for(var i = 0; i < outer.length; i++) {
          if (outer[i].name.toLowerCase() === nameC) {
            return outer[i]
          }  
        }
      } else if (this.sort === 'images') {
        const outer = this.issue.imageContributionsCarousel

        for(var i = 0; i < outer.length; i++) {
          if (outer[i].length && outer[i][0].name.length && outer[i][0].name.toLowerCase() === nameC) {
            return outer[i]
          }  
        }
      } else {
        const outer = this.issue.textContributions

        for(var i = 0; i < outer.length; i++) {
          if (outer[i].name.toLowerCase() === nameC) {
            return outer[i]
          }  
        }
      }
    }
  },
  methods: {
    removeDspaces: function (text) {
      return text.replace(/  +/g, ' ')
    }
  },
  mounted: function () {
    this.$store.state.classBody = 'issueInner'
    this.$store.state.compass = false
    this.$store.state.classBody = 'issueInner'
  }, 
  created: function () {
    this.$store.state.classBody = 'issueInner'
    this.$store.state.classBody = 'issueInner'
  },
  beforeCreated: function () {
    this.$store.state.classBody = 'issueInner'
  },
  beforeRouteLeave (to, from, next) {
    const time = Math.floor(Math.random() * 200) + 10  
    this.$store.state.compass = true 
    setTimeout(function(){ next() }, time)

  },
  beforeRouteEnter (to, from, next) {
  next(vm => {
  vm.$store.state.classBody = 'issueInner'
  })
}
}
</script>

<style lang="less">
  @import "../styles/global.less";
  .contribution_wrap .text p a {
    word-break: break-all;
  }

  .issue_title {
    margin-bottom: @mp-c;
  }

  .image {
    margin: 0 @mp-b @mp-b 0;
    
    width: 540px;
    
    background: @white;
    z-index: 2000000;
    display: inline-block;

    line-height: 0;

    vertical-align: top;
  }

  @media screen and (max-width: @breakpoint1) {
    .image {
      height: auto;
      width: calc(~"100vw - 40px");
      margin: 0;
      margin-bottom: @mp-b;
    }
    .image:last-of-type {
      margin-bottom: 0;
    }
  }
   
</style>



// WEBPACK FOOTER //
// src/components/IssueInner.vue